<template>
  <section class="cl">
    <div class="cl__wrap">
      <!-- ===== Card Superior ===== -->
      <article class="cl__hero">
        <div class="cl__hero-left">
          <h2 class="cl__title-xl">{{ hero.title }}</h2>
          <a
            v-if="hero.href"
            :href="hero.href"
            :target="hero.external ? '_blank' : undefined"
            :rel="hero.external ? 'noopener noreferrer' : undefined"
            class="cl__btn cl__btn-desktop"
          >
            Conoce más
          </a>
        </div>

        <div class="cl__hero-center">
          <ul class="cl__list">
            <li v-for="(it, i) in hero.bullets" :key="i">
              <img class="cl__li-ico" :src="baseUrl(it.icon)" alt="" />
              <span class="cl__li-text">{{ it.text }}</span>
            </li>
          </ul>
        </div>

        <div class="cl__hero-right">
          <!-- Imagen grande derecha -->
          <img
            class="cl__hero-img"
            :src="baseUrl(hero.image)"
            :alt="hero.title"
          />
        </div>

        <div class="cl__hero-bottom">
          <a
            v-if="hero.href"
            :href="hero.href"
            :target="hero.external ? '_blank' : undefined"
            :rel="hero.external ? 'noopener noreferrer' : undefined"
            class="cl__btn"
          >
            Conoce más
          </a>
        </div>
      </article>

      <!-- ===== Fila inferior (2 cards) ===== -->
      <div class="cl__grid">
        <article v-for="(card, i) in cards" :key="i" class="cl__card">
          <div class="cl__card-left">
            <div class="cl__card-content">
              <h3 class="cl__title-lg">{{ card.title }}</h3>
              <p class="cl__desc">{{ card.description }}</p>
            </div>

            <a
              v-if="card.href"
              :href="card.href"
              :target="card.external ? '_blank' : undefined"
              :rel="card.external ? 'noopener noreferrer' : undefined"
              class="cl__btn cl__btn-desktop"
            >
              Conoce más
            </a>
          </div>

          <div class="cl__card-right">
            <div class="cl__img-box">
              <img :src="baseUrl(card.image)" :alt="card.title" />
            </div>
          </div>

          <div class="cl__card-bottom">
            <a
              v-if="card.href"
              :href="card.href"
              :target="card.external ? '_blank' : undefined"
              :rel="card.external ? 'noopener noreferrer' : undefined"
              class="cl__btn"
            >
              Conoce más
            </a>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CardsLanding",
  props: {
    hero: {
      type: Object,
      default: () => ({
        title: "Modelo educativo 360°",
        image: "images/new-version/chart.svg",
        href: "https://www.preupdv.cl/modelo-educativo-360",
        external: true,
        bullets: [
          {
            icon: "images/new-version/book.svg",
            text: "Contenidos y docentes de excelencia",
          },
          {
            icon: "images/new-version/pencil.svg",
            text: "Ejercitación permanente",
          },
          {
            icon: "images/new-version/book-check.svg",
            text: "Evaluación continua",
          },
          {
            icon: "images/new-version/idea.svg",
            text: "Orientación y apoyo permanente",
          },
        ],
      }),
    },
    cards: {
      type: Array,
      default: () => [
        {
          title: "App Preu PDV",
          description:
            "Toda la información académica y diversos recursos de orientación en un solo lugar.",
          image: "images/new-version/app-preu.svg",
          href: "https://www.preupdv.cl/nuestros-recursos",
          external: true,
        },
        {
          title: "App PDV Lab",
          description:
            "Centro de recursos virtuales, interactivos y audiovisuales para apoyar el aprendizaje.",
          image: "images/new-version/pdv-lab.svg",
          href: "https://www.preupdv.cl/nuestros-recursos",
          external: true,
        },
      ],
    },
  },
  methods: {
    baseUrl(path) {
      const base = process.env.BASE_URL || "/";
      return path?.startsWith("/")
        ? path
        : base + (path || "").replace(/^\/+/, "");
    },
  },
};
</script>

<style scoped>
/* ------- Base ------- */
.cl {
  padding: 16px 12px 40px;
  background: #ffffff;
  color: #0f172a;
  font-family: "Poppins", ui-sans-serif, system-ui, -apple-system, Segoe UI,
    Roboto, Helvetica, Arial;
}
.cl__wrap {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}

/* Responsive breakpoints */
@media (min-width: 768px) {
  .cl {
    padding: 20px 20px 56px;
  }
  .cl__wrap {
    padding: 0 24px;
  }
}

@media (min-width: 1024px) {
  .cl {
    padding: 24px 32px 80px;
  }
  .cl__wrap {
    padding: 0 32px;
  }
}

/* Bordes suaves (como el screenshot) */
:root {
  --cl-border: #cacbce;
} /* gray-300 aprox */
.cl__hero,
.cl__card {
  border: 2px solid #cacbce;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0); /* para hover sutil si querés luego */
}

/* ------- Hero ------- */
.cl__hero {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  padding: 16px;
  margin-bottom: 20px;
  position: relative;
}

@media (min-width: 768px) {
  .cl__hero {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    padding: 20px;
    margin-bottom: 24px;
  }
}

@media (min-width: 1024px) {
  .cl__hero {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 16px;
    padding: 28px 28px 24px;
    margin-bottom: 22px;
  }
}

.cl__hero-left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 20px;
}
.cl__hero-left .cl__btn {
  align-self: flex-start;
  margin-top: 44px;
}
.cl__hero-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
}
.cl__hero-right {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  position: relative;
}
.cl__hero-img {
  width: 100%;
  height: auto;
  max-width: 300px;
  max-height: 250px;
  display: block;
  border-radius: 12px;
  object-fit: contain;
  position: relative;
  bottom: 0;
  right: 0;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .cl__hero-img {
    max-width: 350px;
    max-height: 300px;
    position: absolute;
    bottom: -40px;
    right: -20px;
  }
}

@media (min-width: 1024px) {
  .cl__hero-img {
    width: 475px;
    height: 375px;
    max-width: none;
    max-height: none;
    position: absolute;
    bottom: -88px;
    right: -28px;
  }
}

/* Títulos */
.cl__title-xl {
  font-weight: 700;
  font-size: clamp(28px, 4vw, 42px);
  line-height: 1.05;
  letter-spacing: 0;
  margin: 6px 0 4px;
  color: #1b1b1d;
  font-family: "Poppins-Bold", sans-serif;
}

@media (min-width: 768px) {
  .cl__title-xl {
    font-size: clamp(32px, 3.5vw, 38px);
  }
}

@media (min-width: 1024px) {
  .cl__title-xl {
    font-size: clamp(42px, 3.8vw, 48px);
  }
}

.cl__title-lg {
  font-weight: 800;
  font-size: clamp(18px, 3vw, 22px);
  line-height: 1.1;
  margin: 6px 0 10px;
  color: black;
}

@media (min-width: 768px) {
  .cl__title-lg {
    font-size: clamp(20px, 2.5vw, 28px);
  }
}

@media (min-width: 1024px) {
  .cl__title-lg {
    font-size: clamp(22px, 2.8vw, 36px);
  }
}

/* Lista con iconos */
.cl__list {
  list-style: none;
  padding: 0;
  margin: 6px 0 8px;
}
.cl__list li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
}

@media (min-width: 768px) {
  .cl__list li {
    gap: 12px;
    padding: 8px 0;
  }
}

.cl__li-ico {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

@media (min-width: 768px) {
  .cl__li-ico {
    width: 24px;
    height: 24px;
  }
}

.cl__li-text {
  font-family: "Poppins-Medium", sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #1f2937; /* gray-800 */
}

@media (min-width: 768px) {
  .cl__li-text {
    font-size: 16px;
    line-height: 24px;
  }
}

/* ------- Grid inferior ------- */
.cl__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 768px) {
  .cl__grid {
    gap: 20px;
  }
}

@media (min-width: 1024px) {
  .cl__grid {
    grid-template-columns: 1fr 1fr;
    gap: 22px;
  }
}

.cl__card {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding: 16px;
}

@media (min-width: 768px) {
  .cl__card {
    gap: 20px;
    padding: 20px;
  }
}

@media (min-width: 900px) {
  .cl__card {
    grid-template-columns: 1.05fr 0.95fr;
    gap: 24px;
    padding: 24px;
  }
}

.cl__card-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
}

.cl__card-content {
  flex: 1;
}

.cl__card-bottom {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.cl__btn-desktop {
  display: none !important;
}

.cl__card-bottom,
.cl__hero-bottom {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

@media (min-width: 900px) {
  .cl__card-bottom,
  .cl__hero-bottom {
    display: none !important;
  }

  .cl__btn-desktop {
    display: inline-block !important;
  }
}
.cl__desc {
  font-family: "Poppins-Medium", sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #374151; /* gray-700 */
  margin: 6px 0 12px;
}

@media (min-width: 768px) {
  .cl__desc {
    font-size: 14px;
    line-height: 22px;
    margin: 6px 0 16px;
  }
}

.cl__card-right {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cl__img-box {
  width: 100%;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}
.cl__img-box img {
  width: 100%;
  height: auto;
  max-width: 200px;
  max-height: 160px;
  display: block;
  object-fit: contain;
  border-radius: 10px;
}

@media (min-width: 768px) {
  .cl__img-box img {
    max-width: 220px;
    max-height: 180px;
  }
}

@media (min-width: 1024px) {
  .cl__img-box img {
    width: 241px;
    height: 202px;
    max-width: none;
    max-height: none;
  }
}

/* ------- Botón pill ------- */
/* Según Figma: Poppins 16/24, weight 500, pill con borde negro */
.cl__btn {
  align-self: flex-start;
  font-family: "Poppins", sans-serif;
  font-weight: 500; /* Medium */
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #0b0b0b;
  text-decoration: none;
  padding: 6px 20px;
  border: 2px solid #0b0b0b;
  border-radius: 50px !important;
  display: inline-block;
  width: fit-content;
  height: auto;
  min-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  transition: box-shadow 0.2s ease, transform 0.06s ease, color 0.2s ease,
    border-color 0.2s ease;
}

@media (min-width: 768px) {
  .cl__btn {
    font-size: 15px;
    line-height: 22px;
    padding: 7px 15px;
    min-height: 42px;
  }
}

@media (min-width: 1024px) {
  .cl__btn {
    font-size: 16px;
    line-height: 24px;
    padding: 7px 28px;
    min-height: 44px;
  }
}

/* Estilos para mobile muy pequeño */
@media (max-width: 480px) {
  .cl__btn {
    font-size: 12px;
    line-height: 16px;
    padding: 10px 14px;
    min-height: 32px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .cl__card-bottom,
  .cl__hero-bottom {
    justify-content: center;
    align-items: center;
  }
}

/* Estilos para mobile normal */
@media (min-width: 481px) and (max-width: 767px) {
  .cl__btn {
    font-size: 13px;
    line-height: 18px;
    padding: 10px 16px;
    min-height: 36px;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.cl__btn:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}
.cl__btn:active {
  transform: translateY(1px);
}
.cl__btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.25);
}

/* Responsivo fino */
@media (max-width: 480px) {
  .cl__btn {
    width: fit-content;
    justify-content: center;
    font-size: 13px;
    padding: 5px 18px;
    min-height: 36px;
  }

  .cl__hero {
    padding: 12px;
    gap: 16px;
  }

  .cl__card {
    padding: 12px;
    gap: 12px;
  }

  .cl__title-xl {
    font-size: clamp(24px, 4.5vw, 28px);
  }

  .cl__title-lg {
    font-size: clamp(16px, 3.5vw, 18px);
  }
}
</style>
